var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_1172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10673 3.47205C5.51393 3.70258 5.0126 4.00996 4.51128 4.51128C4.00996 5.00894 3.70258 5.51393 3.47205 6.10307C3.24883 6.67392 3.0988 7.32893 3.05489 8.28766C3.01098 9.24639 3 9.55377 3 11.9982C3 14.4426 3.01098 14.7499 3.05489 15.7087C3.0988 16.6674 3.25249 17.3224 3.47205 17.8933C3.70258 18.4861 4.00996 18.9874 4.51128 19.4887C5.0126 19.99 5.51393 20.2974 6.10673 20.528C6.67758 20.7512 7.33259 20.9012 8.29132 20.9451C9.25005 20.989 9.55743 21 12.0018 21C14.4462 21 14.7536 20.989 15.7123 20.9451C16.6711 20.9012 17.3261 20.7475 17.8969 20.528C18.4897 20.2974 18.9911 19.99 19.4924 19.4887C19.9937 18.9874 20.3011 18.4861 20.5316 17.8933C20.7548 17.3224 20.9049 16.6674 20.9488 15.7087C20.9927 14.7499 21.0037 14.4426 21.0037 11.9982C21.0037 9.55377 20.9927 9.24639 20.9488 8.28766C20.9049 7.32893 20.7512 6.67392 20.5316 6.10307C20.3011 5.51393 19.9937 5.00894 19.496 4.51128C18.9947 4.00996 18.4934 3.70258 17.9006 3.47205C17.3297 3.24883 16.6747 3.0988 15.716 3.05489C14.7573 3.01098 14.4499 3 12.0055 3C9.56109 3 9.25371 3.01098 8.29498 3.05489C7.33259 3.09514 6.67758 3.24883 6.10673 3.47205ZM15.6392 4.67229C16.5174 4.71254 16.9931 4.85891 17.3114 4.98333C17.7323 5.148 18.0323 5.34194 18.347 5.65664C18.6617 5.97134 18.8557 6.2714 19.0203 6.69221C19.1447 7.01057 19.2911 7.48628 19.3314 8.3645C19.3753 9.31226 19.3826 9.59768 19.3826 12.0018C19.3826 14.406 19.3716 14.6914 19.3314 15.6392C19.2911 16.5174 19.1447 16.9931 19.0203 17.3114C18.8557 17.7323 18.6617 18.0323 18.347 18.347C18.0323 18.6617 17.7323 18.8557 17.3114 19.0203C16.9931 19.1447 16.5174 19.2911 15.6392 19.3314C14.6914 19.3753 14.406 19.3826 12.0018 19.3826C9.59768 19.3826 9.31226 19.3716 8.36451 19.3314C7.48628 19.2911 7.01057 19.1447 6.69221 19.0203C6.2714 18.8557 5.97134 18.6617 5.65664 18.347C5.34194 18.0323 5.148 17.7323 4.98333 17.3114C4.85891 16.9931 4.71254 16.5174 4.67229 15.6392C4.62838 14.6914 4.62106 14.406 4.62106 12.0018C4.62106 9.59768 4.63204 9.31226 4.67229 8.3645C4.71254 7.48628 4.85891 7.01057 4.98333 6.69221C5.148 6.2714 5.34194 5.97134 5.65664 5.65664C5.97134 5.34194 6.2714 5.148 6.69221 4.98333C7.01057 4.85891 7.48628 4.71254 8.36451 4.67229C9.31226 4.62838 9.59768 4.62106 12.0018 4.62106C14.406 4.62106 14.6914 4.62838 15.6392 4.67229Z",
    fill: "url(#paint0_radial_417_1172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38049 12.002C7.38049 14.5562 9.45165 16.6237 12.0022 16.6237C14.5527 16.6237 16.6238 14.5526 16.6238 12.002C16.6238 9.45152 14.5563 7.38037 12.0022 7.38037C9.44799 7.38037 7.38049 9.44786 7.38049 12.002ZM15.0028 12.002C15.0028 13.6597 13.6598 15.0027 12.0022 15.0027C10.3445 15.0027 9.00155 13.6597 9.00155 12.002C9.00155 10.3444 10.3445 9.00143 12.0022 9.00143C13.6598 9.00143 15.0028 10.3444 15.0028 12.002Z",
    fill: "url(#paint1_radial_417_1172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8104 8.27665C17.4066 8.27665 17.8899 7.79335 17.8899 7.19716C17.8899 6.60098 17.4066 6.11768 16.8104 6.11768C16.2143 6.11768 15.731 6.60098 15.731 7.19716C15.731 7.79335 16.2143 8.27665 16.8104 8.27665Z",
    fill: "#654C9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_417_1172",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.32758 19.352) rotate(-3.00009) scale(26.029 22.1244)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2634,
    stopColor: "#F47133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6091,
    stopColor: "#BC3081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C63D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_417_1172",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.54814 15.7761) rotate(-3.00009) scale(13.3662 11.3612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2634,
    stopColor: "#F47133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6091,
    stopColor: "#BC3081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C63D2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_1172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.6dc919acb9077d4d83e9acb0b4bac413.svg";
export { ForwardRef as ReactComponent };